<div class="container" *ngIf="lessonID != null">
    <div *ngIf="error">
        <app-zero-lessons
        [lessonID]="lessonID"
        ></app-zero-lessons>
    </div>

    <div *ngIf="error == null">
        <app-choose-lessons
        [lessonID]="lessonID"
        >
        </app-choose-lessons>
    </div>
</div>